<template>
  <nav-bar />
  <div>
    <router-view v-if="consentGranted || isStaticRoute" />
    <div v-else-if="consentRejected" class="no-consent">
      <p>Du hast der Datenverarbeitung nicht zugestimmt. Laubloch kann ohne Einwilligung nicht genutzt werden.</p>
      <div class="no-consent-links">
        <router-link to="/datenschutz">Datenschutzerklärung</router-link>
        <router-link to="/impressum">Impressum</router-link>
      </div>
      <button class="no-consent-reset" @click="resetConsent">Einwilligung erneut entscheiden</button>
    </div>
  </div>
  <DSGVOBanner />
</template>

<script>
import NavBar from './components/NavBar.vue'
import DSGVOBanner from './components/DSGVOBanner.vue'
import { consentStatus, resetConsent } from './services/consent.js'

const STATIC_ROUTES = ['/datenschutz', '/impressum']

export default {
  name: "App",
  components: {
    NavBar,
    DSGVOBanner
  },
  computed: {
    consentGranted() {
      return consentStatus.value === 'accepted'
    },
    consentRejected() {
      return consentStatus.value === 'rejected'
    },
    isStaticRoute() {
      return STATIC_ROUTES.includes(this.$route.path)
    }
  },
  methods: {
    resetConsent() {
      resetConsent()
    }
  }
};
</script>

<style>
.no-consent {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  gap: 1.5rem;
  padding: 2rem;
  text-align: center;
  font-family: 'Avenir Next', 'Avenir', sans-serif;
  font-weight: 200;
}

.no-consent p {
  max-width: 500px;
  line-height: 1.6;
}

.no-consent-links {
  display: flex;
  gap: 1.5rem;
}

.no-consent-links a {
  font-style: italic;
  color: black;
  text-decoration: underline;
}

.no-consent-reset {
  font-family: 'Avenir Next', 'Avenir', sans-serif;
  font-size: 0.9375rem;
  font-weight: 200;
  background: #fff;
  border: 1px solid black;
  padding: 0.5rem 1.5rem;
  cursor: pointer;
  transition: background 0.2s;
}

.no-consent-reset:hover {
  background: #f0f0f0;
}
</style>
